// extracted by mini-css-extract-plugin
export var logo = "_kz-2";
export var logoWrapper = "_kz-1";
export var strip = "_kz-0";